export const header = 'LPG W CENIE BENZYNY';
export const button = 'Znajdź samochód';
